import type { ReactNode } from "react";
import { Hotspot, useAccent } from "@/ui";

interface RegionFrameProps {
  /** 1-based region number shown on the hotspot pin. */
  n: number;
  label: string;
  selected: boolean;
  visited: boolean;
  /** True while a *different* region is selected — this one fades back. */
  dimmed: boolean;
  onSelect: () => void;
  regionRef?: (el: HTMLDivElement | null) => void;
  children: ReactNode;
}

/**
 * One clickable block of the mock SERP. Selected → glowing accent ring;
 * everything else dims. A numbered Hotspot pin sits on the top-left corner.
 */
export function RegionFrame({
  n,
  label,
  selected,
  visited,
  dimmed,
  onSelect,
  regionRef,
  children,
}: RegionFrameProps) {
  const [from, to] = useAccent();
  return (
    <div
      ref={regionRef}
      onClick={onSelect}
      className={`relative cursor-pointer rounded-xl p-5 transition-all duration-300 ${
        dimmed ? "opacity-40" : "opacity-100 hover:bg-white/[0.04]"
      }`}
      style={
        selected
          ? {
              boxShadow: `0 0 0 2px ${from}, 0 0 36px -6px ${to}`,
              background: "rgba(255,255,255,0.04)",
            }
          : undefined
      }
    >
      <Hotspot
        n={n}
        selected={selected}
        visited={visited}
        onClick={onSelect}
        label={label}
        className="absolute -left-4 -top-4"
      />
      {children}
    </div>
  );
}
